import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useFilterLabels } from './useFilterLabels'
import { RadioFilter } from '../../common/Filter/RadioFilter'
import { Calculation } from '../../../hooks'
import { ComponentProps } from 'react'
import { Option } from '../../common/Form/types'
import { FilterProps } from '../../common/Filter/types'

export type CalculationFilterProps = {
    name: string
    onChange: (commodityType: Calculation) => void
    value: Calculation
    defaultValue: Calculation
    disabled?: boolean
} & Pick<FilterProps, 'containerRef'>

export const CalculationFilter: React.FC<CalculationFilterProps> = (props) => {
    const { name, disabled, value, defaultValue } = props
    const { t } = useTranslation('translations')
    const labels = useFilterLabels()
    const options: Option<Calculation>[] = (
        ['productionMonth', 'calendarMonth', 'accountingMonth'] as Calculation[]
    ).map((value) => ({
        value,
        label: t(`filters.calculation.options.${value}`),
    }))

    const onChange = (value: unknown) => {
        const selectedCalculation = options.find(
            (option) => option.value === value
        )

        if (selectedCalculation) {
            props.onChange(selectedCalculation.value)
        }
    }

    const passedProps: ComponentProps<typeof RadioFilter> = {
        name,
        label: t('filters.calculation.label'),
        ...labels,
        value,
        defaultValue,
        onChange,
        config: {
            value,
            options,
        },
        disabled,
        containerRef: props.containerRef,
    }

    return <RadioFilter {...passedProps} />
}
